export default "__VITE_ASSET__CFDND347__"